var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"box"},[_c('header',[_c('section',[_vm._t("dropdown"),_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("dropdown-right")],2),(!_vm.isStatic)?_c('button',{on:{"click":function($event){_vm.show = !_vm.show}}},[_c('i',{class:{
        'fas fa-chevron-down': !_vm.show,
        'fas fa-chevron-up' : _vm.show
      }})]):_vm._e()]),(_vm.show)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }